import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import api from "@/lib/api";

const norm = (s) => (s || "").replace(/\s+/g, " ").trim().toLowerCase();

let cache = null;
let inflight = null;

export function usePilotOfMonthName() {
  const [name, setName] = useState(cache ? cache.winner : null);
  useEffect(() => {
    let mounted = true;
    if (cache) { setName(cache.winner); return; }
    if (!inflight) {
      inflight = api.get("/pilot-of-the-month")
        .then((r) => { cache = { winner: (r.data && r.data.pilot && r.data.pilot.name) || null }; return cache; })
        .catch(() => { cache = { winner: null }; return cache; });
    }
    inflight.then((c) => { if (mounted) setName(c.winner); });
    return () => { mounted = false; };
  }, []);
  return name;
}

export default function PilotMonthBadge({ name, className = "" }) {
  const winner = usePilotOfMonthName();
  if (!winner || norm(winner) !== norm(name)) return null;
  return (
    <span data-testid="pilot-month-badge" title="Pilota del Mese"
      className={`inline-flex items-center gap-1 rounded-full border border-yellow-400/50 bg-yellow-400/10 text-yellow-400 text-[9px] font-bold uppercase tracking-wider px-2 py-0.5 ${className}`}>
      <Crown className="h-3 w-3" /> Pilota del Mese
    </span>
  );
}
